import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
  0% {
    background-position-x: -200%;
  }
  100% {
    background-position-x: 200%;
  }
`;

const SkeletonContainer = styled.div`
  background: #f8f9fa;
  padding: 10px;
  border-radius: 12px;
  position: relative;
  height: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.1);
`;

const SkeletonElement = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  background-position-x: -200%;
  animation: 1.5s ${gradientAnimation} ease-in-out infinite;
  border-radius: 4px;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const TitleContainer = styled.div`
  flex: 1;
  text-align: left;
`;

const TitleSkeleton = styled(SkeletonElement)`
  width: 80%;
  height: 28px;
  margin-bottom: 8px;
  border-radius: 6px;
`;

const SubtitleSkeleton = styled(SkeletonElement)`
  width: 60%;
  height: 20px;
  border-radius: 4px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-left: 15px;
  min-height: 60px;
  gap: 8px;
`;

const LabelsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RiskLabelSkeleton = styled(SkeletonElement)`
  width: 100px;
  height: 32px;
  border-radius: 8px;
`;

const ComplianceLabelSkeleton = styled(SkeletonElement)`
  width: 150px;
  height: 32px;
  border-radius: 8px;
`;

const ExpirationSkeleton = styled(SkeletonElement)`
  width: 120px;
  height: 16px;
  border-radius: 4px;
`;

const QuestionSkeleton = ({ id }) => {
  return (
    <SkeletonContainer id={id}>
      <ContentContainer id={`${id}-content`}>
        <TitleContainer id={`${id}-title-container`}>
          <TitleSkeleton id={`${id}-title`} />
          <SubtitleSkeleton id={`${id}-subtitle`} />
        </TitleContainer>
        <RightContainer id={`${id}-right-container`}>
          <LabelsContainer id={`${id}-labels-container`}>
            <RiskLabelSkeleton id={`${id}-risk-label`} />
            <ComplianceLabelSkeleton id={`${id}-compliance-label`} />
          </LabelsContainer>
          <ExpirationSkeleton id={`${id}-expiration`} />
        </RightContainer>
      </ContentContainer>
    </SkeletonContainer>
  );
};

export default QuestionSkeleton;
